// Shared look of all controls (input, select, dropdown button, date).
// One height (36px), one radius (6px), one focus ring, the same in light and dark mode.
export const CONTROL =
  "h-9 rounded-md border border-slate-300 bg-surface px-3 text-sm text-slate-900 placeholder:text-slate-500 " +
  "transition-colors hover:border-slate-400 focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/25 " +
  "disabled:cursor-not-allowed disabled:opacity-50 " +
  "dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100 dark:placeholder:text-slate-400 " +
  "dark:hover:border-slate-600 dark:focus:border-primary-light dark:focus:ring-primary-light/25";

export const LABEL = "text-xs font-medium text-slate-500 dark:text-slate-400";
